import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 16,
  },
}));
